import * as React from 'react'
import { cn } from '../../lib/utils'

export interface PropertyCardHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
	title: string
	subtitle?: string
	badge?: React.ReactNode
	actions?: React.ReactNode
}

function PropertyCardHeader({ title, subtitle, badge, actions, className, ...props }: PropertyCardHeaderProps) {
	return (
		<div
			data-slot="property-card-header"
			className={cn('flex flex-col gap-1 border-b border-(--color-border) bg-(--color-background) p-4', className)}
			{...props}
		>
			<div className="flex items-center gap-3">
				<div className="flex flex-1 items-center gap-3">
					<h1 className="text-2xl font-[500] leading-8 tracking-[-0.6px] text-(--color-foreground)">
						{title}
					</h1>
					{badge}
				</div>
				{actions}
			</div>
			{subtitle && (
				<p className="text-base leading-6 text-(--color-muted-foreground)">{subtitle}</p>
			)}
		</div>
	)
}

PropertyCardHeader.displayName = 'PropertyCardHeader'

export { PropertyCardHeader }
